function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 9c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3-3-1.3-3-3zm3 5c-4.6 0-6 3.3-6 3.3V19h12v-1.7S17.6 14 13 14z",
    style: {
      fill: "var(--primary-color)"
    },
    transform: "translate(-1.0434783 -1.2608698) scale(1.0434783)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "var(--primary-color)"
    },
    transform: "translate(-1.0434783 -1.2608698) scale(1.0434783)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 8.5,
    r: 2.5,
    style: {
      fill: "var(--primary-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13c-1.2 0-2.1.3-2.8.8 2.3 1.1 3.2 3 3.2 3.2v.1H24v-1.3c0-.1-1.1-2.8-4.5-2.8Z",
    style: {
      fill: "var(--primary-color)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.078125-3.1171875h3.123047V.00585938h2.107422V-3.1171875h3.123047v-2.1074219h-3.123047v-3.1230468h-2.107422v3.1230468H7.078125v2.1074219z",
    style: {
      fill: "var(--primary-color)",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "rotate(90)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateGroup);
export default __webpack_public_path__ + "static/media/create-group.2a7957072f93bb69eb3587113aca89a0.svg";
export { ForwardRef as ReactComponent };